/**
 * @version 2.7
 * Embedding:
 * <script id="pa-lib-script" data-id="cm-project-78" data-iframe="true" src="assets/js/paIframeParent.js"></script>
 *
 * Workflow:
 * - parent creates iframe
 * - child initial load
 * - child sends 'childloaded'
 * - parent sends 'data'
 * - child runs application
 * - child send new height and disables loading
 */
export const paIframeParent = {
    // public
    useIframe: true, // you could change that. Should it be loaded via iframe
    browserCache: true, // for debug
    loadingIndication: true,
    autoDisableIndication: null, // if null - do not autodisable
    waitForDom: true, // if script embeded in HEAD we have to wait for DOMready
    dataset: null,


    route: {hash: null},
    //private
    libSource: '',
    libDomHandler: null,
    dom: {},
    toLoad: [],
    init() {
        // if (!this.isBrowser()) {
        //     this.showBrowserUpdate();
        //     return;
        // }
        this.initRoute();
        if (this.waitForDom) {
            if (document.currentScript) {
                this.currentScriptTag = document.currentScript;
            }
            document.addEventListener('DOMContentLoaded', function () {
                this.defines();
                this.initApp();
            }.bind(this));
        } else {
            this.defines();
            this.initApp();
        }

    },
    isBrowser() {
        return typeof document.currentScript !== 'undefined';
    },
    isIE9Nightmare() {
        var sAgent = window.navigator.userAgent,
            isIE = sAgent.indexOf('MSIE'),
            version = parseInt(sAgent.substring(isIE + 5, sAgent.indexOf('.', isIE)));
        return isIE && version <= 9;
    },
    defines() {
        if (!this.iframe) window.paLib = this;
        if (this.isIE9Nightmare()) {
            this.loadingIndication = false;
        }

        if (!this.currentScriptTag) {
            if (document.currentScript) {
                this.currentScriptTag = document.currentScript;
            } else {
                this.currentScriptTag = document.getElementById('pa-lib-script');
            }
        }

        var scriptSrc = this.currentScriptTag.src;
        if (scriptSrc.indexOf('?') > 0) {
            scriptSrc = scriptSrc.substr(0, scriptSrc.indexOf('?'))
        }
        this.libSource = scriptSrc.substr(0, scriptSrc.indexOf('paEngineIframeLoader.js'));

        if (this.currentScriptTag.dataset) {
            this.libDomHandlerId = this.currentScriptTag.dataset.id || 'pa-engine-dom-wrapper';
            this.dataset = this.currentScriptTag.dataset;
        } else {
            this.libDomHandlerId = 'pa-engine-dom-wrapper';
        }

        this.libDomHandler = '#' + this.libDomHandlerId;
        this.createHandler();
        this.dom.handler = document.getElementById(this.libDomHandlerId);

        if (this.dom.handler.dataset) {
            this.lang = typeof this.dom.handler.dataset.lang != 'undefined' ? this.dom.handler.dataset.lang : 'en';
            this.iframe = (this.dom.handler.dataset.iframe == 'false');
        } else {
            this.lang = 'en';
            this.iframe = true;
        }

    },
    showBrowserUpdate() {
        this.currentScriptTag = document.getElementById('pa-lib-script');
        var div = document.createElement('div');
        div.innerHTML = '<div class="alert" style="position: absolute; z-index: 100000; left: 50%;transform: translate(-50%, 0); top: 0;  background: #fff; margin: 0 auto;  padding: 20px; border: 1px solid #000;">Your browser is out-of-date. <a href="http://browser-update.org/update.html">More Info</a></div>';
        this.currentScriptTag.parentNode.insertBefore(div, this.currentScriptTag);
    },
    createHandler() {
        if (document.getElementById(this.libDomHandlerId))return;
        var div = document.createElement('div');
        div.style.position = 'relative';
        div.id = this.libDomHandler.substr(1);
        if (this.loadingIndication) div.innerHTML = this.getLoading();
        this.currentScriptTag.parentNode.insertBefore(div, this.currentScriptTag);
    },
    initRoute() {
        this.route.hash = window.location.hash.substring(1);
        if (window.location.href.indexOf('#') > -1) {
            this.route.base = window.location.href.substr(0, window.location.href.indexOf('#'));
        } else {
            this.route.base = window.location.href;
        }
    },
    initApp() {
        if (this.useIframe) {
            this.initListener(this.libDomHandlerId);
            this.initAppIframeMethod();
        } else {
            this.initAppRequireMethod();
        }
    },
    initListener(id) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
        window[eventMethod](messageEvent, function (e) {
            var data = e[e.message ? 'message' : 'data'];
            // check if this iframe belongs to this lib
            var slashEnd = paIframeParent.libSource.substring(8).search('/'),
                libOrigin = paIframeParent.libSource.substring(0, slashEnd + 8),
                sameOrigin = libOrigin == e.origin,
                sameId = id == e.data.id;

            if (!sameOrigin) {
                console.log('origin conflict');
                return;
            }

            if (sameId && data.task) {
                if (data.task) {
                    if (paLib[data.task]) {
                        paLib[data.task].call(paLib, data);
                    } else {
                        console.log('there is no such method as ' + data.task);
                    }
                }
            }
        }, false);
    },
    initAppIframeMethod() {
        paIframeParent.openIframe();
    },
    fixRoutes(data, exp, targetFolder) {
        targetFolder = targetFolder || 'img';
        exp = exp || /\.\.\/img\//ig;
        return data.replace(exp, this.libSource + targetFolder + '/');
    },
    wrapSrc(src, remote) {
        remote = remote || false;

        var withCache = this.browserCache ? src : src + '?rnd=' + Math.floor((Math.random() * 9999) + 1000);
        return withCache.substr(0, 4) == 'http' && remote ? withCache : this.libSource + withCache;
    },
    openIframe() {
        var iframe = document.createElement('IFRAME');

        if (!this.dataset.id) {
            console.log('Error: no data id property');
            return;
        }
        var url = this.libSource + 'index.html?id=' + this.libDomHandlerId;
        if (typeof this.route.hash != 'undefined' && this.route.hash) {
            url += '#' + this.route.hash
        }
        iframe.setAttribute('src', url);
        iframe.setAttribute('frameborder', 0);
        iframe.style.width = '100%';
        iframe.style.height = '802px';

        iframe.style['margin-bottom'] = '0';
        iframe.style.overflow = 'hidden';
        document.getElementById(this.libDomHandlerId).appendChild(iframe);
        this.iframe = (iframe.contentWindow || iframe.contentDocument);
    },
    childLoaded() {
        var iframeHeight = document.querySelector(this.libDomHandler).offsetHeight,
            iframeWidth = document.querySelector(this.libDomHandler).offsetWidth;
        this.iframe.postMessage({
            task: 'data',
            data: paIframeParent.data,
            libSource: paIframeParent.libSource,
            libDomHandler: paIframeParent.libDomHandler,
            iframeHeight: iframeHeight,
            iframeWidth: iframeWidth
        }, '*');
    },
    changeHeight(data) {
        document.querySelector('#'+data.id + ' > iframe').style.height = data.height + 'px';
    },
    getLoading() {
        var css = '<style type="text/css">.pa-loading{position:absolute;z-index:999;height:100%;width:100%;overflow:visible;margin:auto;top:0;left:0;bottom:0;right:0;padding:20px;margin-left:-20px;background-color:rgba(255,255,255,0.8);border-radius:4px}.pa-loading:before{content:\'\';display:block;position:fixed;top:0;left:0;width:100%;height:100%}.pa-loading:not(:required){font:0/0 a;color:transparent;text-shadow:none;border:0}.pa-loading:not(:required):after{content:\'\';display:block;font-size:10px;width:1em;height:1em;margin-top:-.5em;-webkit-animation:spinner 1500ms infinite linear;-moz-animation:spinner 1500ms infinite linear;-ms-animation:spinner 1500ms infinite linear;-o-animation:spinner 1500ms infinite linear;animation:spinner 1500ms infinite linear;border-radius:.5em;box-shadow:#033069 1.5em 0 0 0,#033069 1.1em 1.1em 0 0,#033069 0 1.5em 0 0,#033069 -1.1em 1.1em 0 0,#033069 -1.5em 0 0 0,#033069 -1.1em -1.1em 0 0,#033069 0 -1.5em 0 0,#033069 1.1em -1.1em 0 0;left:50%;position:absolute;top:150px}@-webkit-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}</style>';
        return css + '<div id="pa-loading-' + paIframeParent.libDomHandlerId + '" class="pa-loading">Loading&#8230;</div>';
    },
    disableLoading(timeout) {
        timeout = timeout || 0;
        setTimeout(function () {
            paIframeParent.removeDOMElement('pa-loading-' + paIframeParent.libDomHandlerId);
        }, timeout);
    },
    removeDOMElement(id) {
        if (document.getElementById(id)) {
            var elem;
            (elem = document.getElementById(id)).parentNode.removeChild(elem)
        }
    }
};
paIframeParent.init();


// WEBPACK FOOTER //
// ./src/js/framework/paIframeParent.js